export default __webpack_public_path__ + "static/media/people15.6f995992.jpeg";